








import Vue from 'vue'
export default Vue.extend({
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 32
    }
  },
  computed: {
    combinedStyle () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      }
    }
  }
})
